import { render, staticRenderFns } from "./EditRecipeModal.vue?vue&type=template&id=f268ecdc"
import script from "./EditRecipeModal.vue?vue&type=script&lang=js"
export * from "./EditRecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports